import SvgIconHelp from '@assets/images/common/icon/header/SvgIconHelp';
import { grayColor, whiteColor } from '@src/assets/colors/defaultColors';

type UserGuideLinkProps = {
  userType: 'tenant' | 'company';
  device: 'pc' | 'mobile';
  color: 'white' | 'gray';
};

const UserGuideLink = ({ userType, device, color }: UserGuideLinkProps) => {
  const url =
    userType === 'tenant'
      ? `${import.meta.env.VITE_HELP_BASE_URL}${import.meta.env.VITE_TENANT_USER_GUIDE_URL}`
      : `${import.meta.env.VITE_HELP_BASE_URL}${import.meta.env.VITE_COMPANY_USER_GUIDE_URL}`;

  const isGray = color === 'gray';
  const textColor = isGray ? 'text-gray-450' : '';

  const className =
    device === 'pc'
      ? `flex items-center justify-center gap-[5px] px-5 py-5 w-[194px] h-[60px] hover:opacity-70 ${textColor}`
      : `mt-6 flex items-center gap-[10px] px-3 py-[20px] text-sm transition-colors ${textColor}`;

  return (
    <a
      href={url}
      target='_blank'
      rel='noopener noreferrer'
      className={className}
      title='ご利用ガイド'
    >
      <SvgIconHelp color={isGray ? grayColor['450'] : whiteColor} />
      {device === 'pc' && (
        <span
          className={`whitespace-nowrap text-base leading-[150%] ${isGray ? 'text-gray-450' : 'text-white'}`}
        >
          ご利用ガイド
        </span>
      )}
      {device === 'mobile' && 'ご利用ガイド'}
    </a>
  );
};

export default UserGuideLink;
